import { useEffect, useRef, useState } from "react"

/**
 * Dispara uma unica vez quando o elemento entra na viewport.
 *
 * O observer se desconecta na primeira intersecao: as animacoes de entrada sao
 * de entrada, nao de ida e volta. Sem o disconnect, sair e voltar ao topo faz o
 * conteudo reanimar a cada scroll.
 */
export function useInView<T extends HTMLElement = HTMLElement>(options?: IntersectionObserverInit) {
  const ref = useRef<T>(null)
  const [inView, setInView] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    // Ambiente de teste (jsdom) nao implementa IntersectionObserver. Sem esta
    // guarda, todo componente com animacao de entrada quebra no vitest.
    if (typeof IntersectionObserver === "undefined") {
      setInView(true)
      return
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true)
          observer.disconnect()
        }
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px", ...options },
    )

    observer.observe(el)
    return () => observer.disconnect()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { ref, inView }
}
